/**
 * Blocks Trustpilot app Micro Review Count on the homepage.
 * The official widget renders #tp-widget-* inside an iframe; parent page
 * only has .trustpilot-widget + iframe — hide/remove those on the storefront.
 * Does not affect the theme's custom trustpilot-badge section.
 */
(function () {
  var MICRO_REVIEW_TEMPLATE_ID = '5419b6a8b0d04a076446a9ad';
  var CUSTOM_BADGE_SELECTOR = '.trustpilot-badge, .shopify-section--trustpilot-badge';

  function isCustomBadgeWidget(node) {
    return !!(node && node.closest && node.closest(CUSTOM_BADGE_SELECTOR));
  }

  function isAppMicroReviewWidget(node) {
    if (!node || !node.getAttribute) {
      return false;
    }

    if (isCustomBadgeWidget(node)) {
      return false;
    }

    if (node.classList && node.classList.contains('trustpilot-widget')) {
      var templateId = node.getAttribute('data-template-id');
      return !templateId || templateId === MICRO_REVIEW_TEMPLATE_ID;
    }

    if (node.tagName === 'IFRAME') {
      var src = node.getAttribute('src') || '';
      return /trustpilot\.com/i.test(src);
    }

    return false;
  }

  function removeTrustpilotAppWidget() {
    document.querySelectorAll('.trustpilot-widget').forEach(function (node) {
      if (isAppMicroReviewWidget(node)) {
        node.remove();
      }
    });

    document.querySelectorAll('iframe[src*="trustpilot"]').forEach(function (node) {
      if (!isCustomBadgeWidget(node)) {
        node.remove();
      }
    });

    document
      .querySelectorAll('#tp-widget-wrapper, #tp-widget-loader, .tp-widget-wrapper, .tp-widget-loader')
      .forEach(function (node) {
        if (!isCustomBadgeWidget(node)) {
          node.remove();
        }
      });
  }

  function patchTrustpilotLoader() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
      return false;
    }

    if (window.Trustpilot.loadFromElement.__miradorHomeBlocked) {
      return true;
    }

    var originalLoad = window.Trustpilot.loadFromElement;

    window.Trustpilot.loadFromElement = function (element, force) {
      if (isAppMicroReviewWidget(element)) {
        return;
      }

      return originalLoad.call(this, element, force);
    };

    window.Trustpilot.loadFromElement.__miradorHomeBlocked = true;
    return true;
  }

  removeTrustpilotAppWidget();

  var patchAttempts = 0;
  var patchTimer = setInterval(function () {
    patchAttempts += 1;

    if (patchTrustpilotLoader() || patchAttempts > 200) {
      clearInterval(patchTimer);
    }
  }, 25);

  if (document.documentElement) {
    new MutationObserver(removeTrustpilotAppWidget).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', removeTrustpilotAppWidget);
  window.addEventListener('load', removeTrustpilotAppWidget);
})();
